export const isSecureContextOk = (): boolean => {
  if (window.isSecureContext) return true;
  return ["localhost", "127.0.0.1"].includes(window.location.hostname);
};

export const startCamera = async (
  videoEl: HTMLVideoElement,
): Promise<MediaStream> => {
  if (!navigator.mediaDevices?.getUserMedia) {
    const err = new Error("getUserMedia no disponible");
    err.name = "NotSupportedError";
    throw err;
  }
  const stream = await navigator.mediaDevices.getUserMedia({
    video: {
      facingMode: { ideal: "environment" },
      width: { ideal: 1920 },
      height: { ideal: 1080 },
    },
    audio: false,
  });
  videoEl.srcObject = stream;
  videoEl.setAttribute("playsinline", "");
  videoEl.muted = true;
  await new Promise<void>((resolve) => {
    if (videoEl.readyState >= 1) return resolve();
    videoEl.addEventListener("loadedmetadata", () => resolve(), { once: true });
  });
  await videoEl.play();
  return stream;
};

export const stopCamera = (stream: MediaStream | null): void => {
  if (!stream) return;
  for (const track of stream.getTracks()) track.stop();
};
